import {Component, EventEmitter, Input, Output, Injectable} from '@angular/core';
import {BaseComponent, BaseListFilterWithSpecs, PropertiesQuery, PropertyQuery} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {NgModel} from "@angular/forms";

@Component({
  selector: 'app-spec-search-menu-item',
  templateUrl: './spec-search-menu-item.component.html',
  styles: [
  ]
})
export class SpecSearchMenuItemComponent extends BaseComponent {
  @Input() relevantSpecs: { Key: string, Value: any[] }[] = [];
  @Input() tableDropdownClosed: EventEmitter<void>;
  @Input() filterData: BaseListFilterWithSpecs;
  @Input() showIncludeInheritedSpecs = true;
  @Input() showIncludeSpecConstraints = true;
  @Output() selectionChange: EventEmitter<PropertyQuery> = new EventEmitter<PropertyQuery>();
  @Output() showOnlyRelevantSpecsChange = new EventEmitter<boolean>();
  @Output() includeInheritedValuesChange = new EventEmitter<boolean>();
  @Output() includeSpecConstraintsValuesChange = new EventEmitter<boolean>();
  specSearch: string;

  constructor(public propertiesQuery: PropertiesQuery) {
    super();
  }

  ngOnInit() {
    this.tableDropdownClosed?.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.specSearch = null;
    });
  }
}
